<div class="header">Notifications</div>
@if (isAdmin) {
  <div class="actions">
    <button pButton label="New Admin Message" class="p-button-secondary" icon="true" (click)="openNotificationDialog($event)"><fa-icon [icon]="faCommentLines" ></fa-icon></button>
  </div>
}
<div class="notifications">
  @for (notification of notifications; track notification) {
    <wm-display-notification [notification]="notification" [seenDate]="seenDate"></wm-display-notification>
  }
  @if (!notifications) {
    <div class="loading-spinner">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  @if (!!notifications && notifications.length === 0) {
    <div class="empty">
      There are no notifications
    </div>
  }
</div>
